// ----------------------------------------------------------------------
// <copyright file="Izenda.NotificationBoard.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

!(function () {

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var classnames = require('classnames');
  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');

  var MESSAGE_TYPE = require('share/messages/Izenda.CommonMessages').MESSAGE_TYPE;

  var NotificationBoard = React.createClass({

    getInitialState: function () {
      return {
        show: false
      }
    },

    getDefaultProps: function () {
      return {
        notificationMessages: []
      }
    },

    render: function () {

      var numberOfMessage = this.props.notificationMessages.length;
      var isShowBadge = numberOfMessage > 0;

      return (
        <div className="izenda-NotificationBoard u-posRelative">
          <span onClick={this.toggleNotification} className='icon-alert' />
          {isShowBadge && <span className="badge u-posAbsolute u-bgRed">{numberOfMessage}</span>}
          {this.state.show && <span className="icon-triangle-up u-posAbsolute u-colorWhite" />}
          {this.state.show && this.renderNotification()}
        </div>
      )
    },

    renderNotification: function () {
      var notificationMessages = this.props.notificationMessages;
      var isHaveMessage = notificationMessages.length > 0;

      return (
        <div className="izenda-NotificationBoard-Message u-posAbsolute u-bgWhite u_borderAll u_paddingAll">
          { isHaveMessage
              ? <ScrollBox autoHeight autoHeightMax={window.innerHeight/2}>
                  <GridLayout className="u_marginBottom u_paddingAll">
                  {notificationMessages.map(function (item) {
                    return (
                      <GridLayout.Row key={item.key}>
                        <GridLayout.Col cols={2}>
                          <span className={getIconTypeClass(item.type)} />
                        </GridLayout.Col>
                        <GridLayout.Col className="u_borderBottom" cols={10}>
                          <span>{item.message}</span>
                        </GridLayout.Col>
                      </GridLayout.Row>
                    )

                  })}
                  </GridLayout>
                </ScrollBox>
              : <div className="u_controlHeight u_marginBottom">No Notification</div>
          }
          <span onClick={this.toggleNotification} className="icon-cancel u_floatRight u_marginRight" />
        </div>
      );

      function getIconTypeClass (type) {
        return classnames({
          'icon-info-circled': type === MESSAGE_TYPE.INFO,
          'icon-error-circled': type === MESSAGE_TYPE.ERROR,
          'icon-attention-circled': type === MESSAGE_TYPE.WARNING,
        })
      }
    },

    toggleNotification: function () {
      this.setState({
        show: !this.state.show
      })
    }

  });

  module.exports = connect()(NotificationBoard);

}());


// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.NotificationBoard.jsx